import React from 'react'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  broadcastMessageListProps$,
  setBroadcastList,
  setBroadcastMessageList,
  setBroadcastMessageListProps,
  setBroadcastMessageValues,
  setBroadcastPatientList,
  setBroadcastValues
} from 'src/store/modules/admin/broadcast'

import ErrorMessages from 'src/components/ErrorMessages'
import {
  BROADCAST_MESSAGE_SUCCESS_DELETE_MESSAGE,
  BROADCAST_MESSAGE_SUCCESS_SAVE_MESSAGE,
  BROADCAST_SUCCESS_DELETE_MESSAGE,
  BROADCAST_SUCCESS_SAVE_MESSAGE,
  GET_BROADCAST_LIST,
  GET_BROADCAST_MESSAGE_LIST,
  GET_BROADCAST_MESSAGE_VALUES,
  GET_BROADCAST_PATIENT,
  GET_BROADCAST_PATIENT_WITH_UUID,
  GET_BROADCAST_VALUES
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const saveBroadcastMessageValues =
  ({ payload = {} }) =>
  async () => {
    try {
      await httpClient.request({
        method: 'post',
        url: { pathname: GET_BROADCAST_MESSAGE_LIST },
        payload
      })

      showSuccessModal({
        content: BROADCAST_MESSAGE_SUCCESS_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateBroadcastMessageValues =
  ({ params = {}, payload = {} }, showModal = true) =>
  async () => {
    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_BROADCAST_MESSAGE_VALUES,
          params
        },
        payload
      })

      if (showModal) {
        showSuccessModal({
          content: BROADCAST_MESSAGE_SUCCESS_SAVE_MESSAGE,
          centered: true,
          keyboard: false
        })
      }

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteBroadcastMessageValues =
  ({ params = {} }) =>
  async (dispatch) => {
    try {
      const { items = [] } = await httpClient.request({
        method: 'delete',
        url: {
          pathname: GET_BROADCAST_MESSAGE_VALUES,
          params
        }
      })

      dispatch(setBroadcastMessageValues(items))

      showSuccessModal({
        content: BROADCAST_MESSAGE_SUCCESS_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchBroadcastMessageList =
  ({ query }) =>
  async (dispatch, getState) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_BROADCAST_MESSAGE_LIST,
          query
        }
      })

      const messageListProps = broadcastMessageListProps$(getState())
      const updMessageListProps = {
        ...messageListProps,
        pagination: {
          ...messageListProps.pagination,
          total: meta.totalItems,
          current: meta.page
        }
      }

      dispatch(setBroadcastMessageList(items))
      dispatch(setBroadcastMessageListProps(updMessageListProps))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchBroadcastValues =
  ({ params = {} }) =>
  async (dispatch) => {
    try {
      const broadcastValues = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_BROADCAST_VALUES,
          params
        }
      })

      dispatch(setBroadcastValues(broadcastValues))
    } catch (err) {
      catchError(err)
    }
  }

export const saveBroadcastValues =
  ({ payload = {} }, history) =>
  async () => {
    try {
      await httpClient.request({
        method: 'post',
        url: { pathname: GET_BROADCAST_LIST },
        payload
      })

      showSuccessModal({
        content: BROADCAST_SUCCESS_SAVE_MESSAGE,
        centered: true,
        keyboard: false,
        onOk: () => {
          if (history) {
            history.push('/actions/broadcast-grid')
          } else {
            return null
          }
        }
      })
    } catch (err) {
      return catchError(
        {
          ...err,
          message: <ErrorMessages errorObj={err} />
        },
        {
          width: 400
        }
      )
    }
  }

export const updateBroadcastValues =
  ({ params = {}, payload = {} }, history) =>
  async () => {
    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_BROADCAST_VALUES,
          params
        },
        payload
      })

      showSuccessModal({
        content: BROADCAST_SUCCESS_SAVE_MESSAGE,
        centered: true,
        keyboard: false,
        onOk: () => history.push('/actions/broadcast-grid')
      })
    } catch (err) {
      return catchError(
        {
          ...err,
          message: <ErrorMessages errorObj={err} />
        },
        {
          width: 400
        }
      )
    }
  }

export const deleteBroadcastValues =
  ({ params = {} }) =>
  async () => {
    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: GET_BROADCAST_VALUES,
          params
        }
      })

      showSuccessModal({
        content: BROADCAST_SUCCESS_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchBroadcastList =
  ({ query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_BROADCAST_LIST,
          query
        }
      })

      dispatch(setBroadcastList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchBroadcastPatientList =
  ({ query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_BROADCAST_PATIENT,
          query
        }
      })

      dispatch(setBroadcastPatientList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchBroadcastPatientListWithUuid =
  ({ params = {}, query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_BROADCAST_PATIENT_WITH_UUID,
          params,
          query
        }
      })

      dispatch(setBroadcastPatientList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }
